export const appSettingsCustomEventsTags = "/app_settings/custom_events_tags";
